.floor {
  fill: var(--color-accent-100);
}
.tileLine {
  fill: none;
  stroke: var(--color-accent-200);
  stroke-width: 1;
}
.wall {
  fill: none;
  stroke: var(--color-neutral-600);
  stroke-width: 14;
  stroke-linecap: square;
}
.window {
  fill: var(--color-accent-300);
}
.door {
  stroke: var(--color-neutral-600);
  stroke-width: 4;
}
.doorSwing {
  fill: none;
  stroke: var(--color-neutral-400);
  stroke-width: 1.5;
  stroke-dasharray: 5 4;
}
.furniture {
  fill: var(--color-neutral-300);
  stroke: var(--color-neutral-400);
  stroke-width: 1.5;
}
.bed {
  fill: var(--color-surface);
  stroke: var(--color-neutral-500);
  stroke-width: 2;
}
.pillow {
  fill: var(--color-neutral-200);
  stroke: var(--color-neutral-400);
  stroke-width: 1.5;
}
.blanket {
  fill: var(--color-accent-300);
}
.fold {
  stroke: var(--color-accent-500);
  stroke-width: 2;
}
